export const GAME_STARTED = "GAME_STARTED"
export const SELECT_ROW = "SELECT_ROW";
export const MIX_CARDS = "MIX_CARDS";
export const HIDDEN = "HIDDEN";
export const SET_ROUND = "SET_ROUND";
export const ROW_SELECT = "ROW_SELECT";
export const STARTED_DISABLED = "STARTED_DISABLED";
export const RESET_ROUND = "RESET_ROUND";
export const RESET_BACKGROUND = "RESET_BACKGROUND";
export const RESET_CARDS = "RESET_CARDS";
export const REVEAL_CARD = "REVEAL_CARD";
export const SET_TEXT = "SET_TEXT";
